import { Capacitor } from '@capacitor/core';

export const getCurrentReturnTo = () =>
  window.location.pathname + window.location.search + window.location.hash

export const redirectToClientLogin = (returnTo = getCurrentReturnTo()) => {
  if (Capacitor.isNativePlatform()) {
    // Native app: redirect to local login page instead of web-based login
    window.location.href = `/login?redirect=${encodeURIComponent(returnTo)}`
  } else {
    // Web: use existing BFF login flow
    window.location.href = `/api/client/login?redirect=${encodeURIComponent(returnTo)}`
  }
}

export const redirectToClientLogout = (returnTo = '/') => {
  if (Capacitor.isNativePlatform()) {
    // Native app: redirect to local login page after logout
    window.location.href = `/login`
  } else {
    // Web: use existing BFF logout flow
    window.location.href = `/api/client/logout?redirect=${encodeURIComponent(returnTo)}`
  }
}
